import { BASE_PATH as d, BaseAPI as A, operationServerMap as b } from "../base.js";
import { DUMMY_BASE_URL as v, assertParamExists as p, createRequestFunction as k, serializeDataIfNeeded as u, setSearchParams as O, toPathString as m } from "../common.js";
import R from "axios";
var V = function(r) {
  return {
    cashierCashbackCancel: async (c, s = {}) => {
      p("cashierCashbackCancel", "cashbackOrderActionRequestDTO", c);
      const h = new URL("/cashier/cashback/cancel", v);
      let e;
      r && (e = r.baseOptions);
      const a = {
        method: "POST",
        ...e,
        ...s
      }, t = {}, o = {};
      t["Content-Type"] = "application/json", O(h, o);
      let n = e && e.headers ? e.headers : {};
      return a.headers = {
        ...t,
        ...n,
        ...s.headers
      }, a.data = u(c, a, r), {
        url: m(h),
        options: a
      };
    },
    cashierCashbackConfirm: async (c, s = {}) => {
      p("cashierCashbackConfirm", "cashbackOrderActionRequestDTO", c);
      const h = new URL("/cashier/cashback/confirm", v);
      let e;
      r && (e = r.baseOptions);
      const a = {
        method: "POST",
        ...e,
        ...s
      }, t = {}, o = {};
      t["Content-Type"] = "application/json", O(h, o);
      let n = e && e.headers ? e.headers : {};
      return a.headers = {
        ...t,
        ...n,
        ...s.headers
      }, a.data = u(c, a, r), {
        url: m(h),
        options: a
      };
    },
    cashierCashbackReserve: async (c, s = {}) => {
      p("cashierCashbackReserve", "cashbackReserveRequestDTO", c);
      const h = new URL("/cashier/cashback/reserve", v);
      let e;
      r && (e = r.baseOptions);
      const a = {
        method: "POST",
        ...e,
        ...s
      }, t = {}, o = {};
      t["Content-Type"] = "application/json", O(h, o);
      let n = e && e.headers ? e.headers : {};
      return a.headers = {
        ...t,
        ...n,
        ...s.headers
      }, a.data = u(c, a, r), {
        url: m(h),
        options: a
      };
    }
  };
}, C = function(r) {
  const c = V(r);
  return {
    async cashierCashbackCancel(s, h) {
      var e, a;
      const t = await c.cashierCashbackCancel(s, h), o = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, n = (a = b["CashbackCashierApi.cashierCashbackCancel"]) === null || a === void 0 || (a = a[o]) === null || a === void 0 ? void 0 : a.url;
      return (i, l) => k(t, R, d, r)(i, n || l);
    },
    async cashierCashbackConfirm(s, h) {
      var e, a;
      const t = await c.cashierCashbackConfirm(s, h), o = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, n = (a = b["CashbackCashierApi.cashierCashbackConfirm"]) === null || a === void 0 || (a = a[o]) === null || a === void 0 ? void 0 : a.url;
      return (i, l) => k(t, R, d, r)(i, n || l);
    },
    async cashierCashbackReserve(s, h) {
      var e, a;
      const t = await c.cashierCashbackReserve(s, h), o = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, n = (a = b["CashbackCashierApi.cashierCashbackReserve"]) === null || a === void 0 || (a = a[o]) === null || a === void 0 ? void 0 : a.url;
      return (i, l) => k(t, R, d, r)(i, n || l);
    }
  };
}, y = function(r, c, s) {
  const h = C(r);
  return {
    cashierCashbackCancel(e, a) {
      return h.cashierCashbackCancel(e.cashbackOrderActionRequestDTO, a).then((t) => t(s, c));
    },
    cashierCashbackConfirm(e, a) {
      return h.cashierCashbackConfirm(e.cashbackOrderActionRequestDTO, a).then((t) => t(s, c));
    },
    cashierCashbackReserve(e, a) {
      return h.cashierCashbackReserve(e.cashbackReserveRequestDTO, a).then((t) => t(s, c));
    }
  };
}, T = class extends A {
  cashierCashbackCancel(r, c) {
    return C(this.configuration).cashierCashbackCancel(r.cashbackOrderActionRequestDTO, c).then((s) => s(this.axios, this.basePath));
  }
  cashierCashbackConfirm(r, c) {
    return C(this.configuration).cashierCashbackConfirm(r.cashbackOrderActionRequestDTO, c).then((s) => s(this.axios, this.basePath));
  }
  cashierCashbackReserve(r, c) {
    return C(this.configuration).cashierCashbackReserve(r.cashbackReserveRequestDTO, c).then((s) => s(this.axios, this.basePath));
  }
};
export {
  T as CashbackCashierApi,
  V as CashbackCashierApiAxiosParamCreator,
  y as CashbackCashierApiFactory,
  C as CashbackCashierApiFp
};

//# sourceMappingURL=cashback-cashier-api.js.map